module.exports = __webpack_public_path__ + "img/logo_dk_mark_ws.ade4fae1.png";